import React from "react";
import Heading from "@react/react-spectrum/Heading";
import { I18n, Translate } from "react-redux-i18n";

import unauthorisedImg from "./errors/error_images/unauthorised.png";
import "./errors/AppError.scss";
import "./RestrictedCountryBanner.scss";
import "./RestrictedSanctionPartnerPage.scss";

/**
 * Full-page block for RU/BY partners on flows that cannot proceed (e.g. Renewal, Uplevel).
 */
function RestrictedSanctionPartnerPage() {
  return (
    <div className="app-error-page restricted-sanction-partner-page" role="alert">
      <div className="app-error-page__inner page-container">
        <div className="app-error-page__illustration-wrap" aria-hidden>
          <img
            src={unauthorisedImg}
            alt=""
            className="app-error-page__illustration"
            style={{ width: "150px", height: "100px" }}
          />
        </div>
        <div className="app-error-page__title-wrap">
          <Heading
            variant="pageTitle"
            style={{ fontWeight: "600", fontSize: "22px", color: "#6c6c6c" }}
          >
            {I18n.t("global.errors.unauthorized")}
          </Heading>
        </div>
        <div
          className="restricted-sanction-partner-page__message restricted-country-banner"
          role="status"
        >
          <Translate value="managePartnership.restrictedSanctionBannerMessage" />
        </div>
      </div>
    </div>
  );
}

export default RestrictedSanctionPartnerPage;
